// extracted by mini-css-extract-plugin
module.exports = {"ecgLoader":"EcgLoader_ecgLoader__3hX77","pulse":"EcgLoader_pulse__31kEN","dash":"EcgLoader_dash__305_f"};